import { updateHistoryStackAfterDraw } from '../../utils/undoRedoUtils.js'
import {
  getBoundaryPoints,
  getCircleBoundaryPoints,
  getTriangleBoundaryPoints,
} from '../../utils/utils.js'

/**
 * 도형 그리기 종료 처리
 * - 도형 경계 계산
 * - undo/redo 기록
 */
export const handleShapeUp = (state) => {
  const {
    boardId,
    ////////
    paths,
    currentPath,
    currentPathId,
    historyStack,
    setHistoryStack,
    // 동시편집
    triggerUpdatePath,
  } = state

  const lastPath = paths[currentPathId.current]

  if (lastPath.type === 'square' || lastPath.type === 'line') {
    getBoundaryPoints(lastPath.type, lastPath)
  } else if (lastPath.type === 'triangle') {
    getTriangleBoundaryPoints(lastPath)
  } else if (lastPath.type === 'circle') {
    getCircleBoundaryPoints(
      lastPath.minX === 0 ? lastPath.maxX / 2 : lastPath.minX / 2,
      lastPath.minY === 0 ? lastPath.maxY / 2 : lastPath.minY / 2,
      Math.abs(lastPath.maxX - lastPath.minX) / 2,
      Math.abs(lastPath.maxY - lastPath.minY) / 2,
      lastPath
    )
  } else {
    console.log('shape up type error')
  }
  // lastPath.type === 'square' || lastPath.type === 'line'
  //   ? getBoundaryPoints(lastPath.type, lastPath)
  //   : lastPath.type === 'triangle'
  //   ? getTriangleBoundaryPoints(lastPath)
  //   : getCircleBoundaryPoints(
  //       lastPath.minX === 0 ? lastPath.maxX / 2 : lastPath.minX / 2,
  //       lastPath.minY === 0 ? lastPath.maxY / 2 : lastPath.minY / 2,
  //       Math.abs(lastPath.maxX - lastPath.minX) / 2,
  //       Math.abs(lastPath.maxY - lastPath.minY) / 2,
  //       lastPath
  //     )

  currentPath.current = paths[currentPathId.current] // 동기화
  triggerUpdatePath(currentPathId.current, lastPath, 'replace')

  // [undo/redo] 기록
  updateHistoryStackAfterDraw({
    boardId,
    currentPath,
    currentPathId,
    historyStack,
    setHistoryStack,
  })

  // 상태 초기화
  currentPath.current = null
  currentPathId.current = 0
}
